import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  DialogContent,
  ButtonBase,
  DialogTitle,
  Grid,
  Divider,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { makeStyles, Theme } from '@material-ui/core/styles'
import DocumentAddToCart from './DocumentAddToCart'
import SubscriptionAddToCart from './SubscriptionAddToCart'
import { staticContent } from '@src/routes'
import { Link } from '@src/components/Link'
import { useUserSession } from '@utils/useUserSession'

const useStyles = makeStyles((theme: Theme) => {
  return {
    dialogHeader: {
      fontSize: theme.typography.pxToRem(28),
      fontWeight: theme.typography.fontWeightBold,
      padding: theme.spacing(8, 8, 0, 8),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },
    closeIcon: {
      fontSize: theme.typography.pxToRem(30),
    },
    subHeader: {
      fontSize: theme.typography.pxToRem(16),
      paddingBottom: theme.typography.pxToRem(20),
    },
    dialogBody: {
      paddingLeft: theme.spacing(10),
      paddingRight: theme.spacing(10),
    },
    divider: {
      paddingLeft: theme.spacing(20),
    },
    moreInfo: {
      fontSize: theme.typography.pxToRem(16),
      padding: theme.spacing(9, 0, 5, 0),
    },
    subscriptionSection: {
      paddingRight: theme.spacing(10),
    },
  }
})

const AddToCart = ({ handleClose, document }) => {
  const classes = useStyles()
  const { userSession } = useUserSession()

  return (
    <Grid container>
      <DialogTitle disableTypography classes={{ root: classes.dialogHeader }}>
        <FormattedMessage id="EMPROVE_SUITE" defaultMessage="Emprove® Suite" />

        <ButtonBase onClick={() => handleClose()}>
          <CloseIcon classes={{ root: classes.closeIcon }} />
        </ButtonBase>
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogBody }}>
        <div className={classes.subHeader}>
          <FormattedMessage
            id="PURCHASE_INDIVIDUALLY_OR_SUBSCRIBE"
            defaultMessage=" Purchase Emprove® dossiers individually or subscribe to the full Emprove® Suite.,"
          />
        </div>
        <Grid container>
          <Grid item xs={4}>
            <DocumentAddToCart document={document} handleClose={handleClose} />
          </Grid>
          <Grid item xs={2} className={classes.divider}>
            <Divider orientation="vertical" />
          </Grid>
          <Grid item xs={6} className={classes.subscriptionSection}>
            <SubscriptionAddToCart handleClose={handleClose} />
          </Grid>
        </Grid>
        <Grid className={classes.moreInfo}>
          <FormattedMessage
            id="HAVE_EMPROVE_QUESTIONS"
            defaultMessage="Still have Emprove® Program questions? {findOutMore}"
            values={{
              findOutMore: (
                <Link
                  {...staticContent.index({
                    path: '/services/product-services/emprove-program',
                    language: userSession.language,
                    country: userSession.country,
                  })}
                >
                  <a target="_blank">
                    <FormattedMessage
                      id="FIND_OUT_MORE"
                      defaultMessage="Find out more."
                    />
                  </a>
                </Link>
              ),
            }}
          />
        </Grid>
      </DialogContent>
    </Grid>
  )
}

export default AddToCart
